import i18n from "../services/i18n"

// tog'a #2696 (2026-09-24, «tarjimalarga e'tiborli bo'l»): «Кошелёк» → «Расходы» jadvalida xarajat turi XOM KOD bo'lib chiqardi
// (transport, salary, customs, certification). Barqaror kod (mainExpense.TypeCode) → joriy tildagi nom — «Расходы» sahifasidagi
// qisqa toifa nomlari bilan bir xil kalitlar. Noma'lum kod — saqlangan nom (fallback) yoki kodning o'zi.
const KEYS: Record<string, [string, string]> = {
  customs: ["customsClearance", "Растаможка"],
  transport: ["transport", "Транспорт"],
  packing: ["packagingCat", "Упаковка"],
  certification: ["certificationCat", "Сертификация"],
  salary: ["salaries", "Зарплата"],
  utilities: ["utilitiesCat", "Коммунальные"],
  other: ["otherCategory", "Прочие"],
}

export function expenseTypeLabel(code?: string | null, fallback?: string | null): string {
  const k = KEYS[String(code || "").trim().toLowerCase()]
  if (k) return i18n.t(k[0], k[1])
  return fallback || code || "—"
}
